export const ACTION_PREFIX = 'app/entity';
export const SOMETHING = '';
